module.exports = __webpack_public_path__ + "assets/img/icon-z1-2.171da8dc.png";